// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoPlayer__root_3VT_u","as-player":"VideoPlayer__as-player_3k0pb","asPlayer":"VideoPlayer__as-player_3k0pb"};